import { css, cx } from '@emotion/css';
import { ResetPasswordForm } from './ResetPasswordForm';
import { Layout } from '../../shared/components/layout/Layout';
import { h1Style } from '../../shared/styles/text';
import {
  authHeaderStyle,
  authSubtitleStyle,
} from '../../shared/styles/auth-layout';

export const ResetPasswordPage = (): JSX.Element => {
  return (
    <Layout.Content className={pageStyle}>
      <h1 className={cx(h1Style, authHeaderStyle)}>Reset your password</h1>
      <p className={authSubtitleStyle}>
        Choose a new password of at least 10 characters.
      </p>
      <ResetPasswordForm />
    </Layout.Content>
  );
};

const pageStyle = css`
  padding-top: 1.5rem;
`;
